<mat-card class="cur-card">
    <mat-card-header>
        <mat-card-title>検索結果</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="table-responsive" style="border: solid 1px rgba(0, 0, 0, 0.12); margin-bottom: 20px">
            <table id="searchResult" mat-table [dataSource]="dataSource" matSort
                style="width: 100%; min-width: 1650px; border: solid 1px rgba(0, 0, 0, 0.12);" #sort1="matSort">
                <ng-container matColumnDef="approve">
                    <th mat-header-cell class="border-bottom-double text-center" *matHeaderCellDef
                        style="min-width: 2em; width: 2em; padding-right: 15px;">対象</th>
                    <td mat-cell *matCellDef="let row" class="table-cell-type-select">
                        <mat-checkbox [disabled]="row.lossyoteiStsCode == LOSSYOTEI_STS_CODE_FINAL_APPROVAL"
                            (click)="$event.stopPropagation()" (change)="onCheckboxChange($event,row,false)"
                            [checked]="selection.isSelected(row) || row.checked" color="primary">
                        </mat-checkbox>
                    </td>
                </ng-container>
                <ng-container matColumnDef="request">
                    <th mat-header-cell style="min-width: 2em; width: 2em; padding-right: 15px;"
                        class="border-bottom-double" *matHeaderCellDef>依頼</th>
                    <td mat-cell style="width: 2em;;" class="table-cell-type-select" *matCellDef="let row">
                        <mat-checkbox (click)="$event.stopPropagation()" (change)="onCheckboxChange($event,row,true)"
                            [checked]="selection.isSelected(row) || row.checked" color="primary">
                        </mat-checkbox>
                    </td>
                </ng-container>
                <ng-container *ngIf="!aprovalmodeFlg" matColumnDef="lossRsncod">
                    <th mat-header-cell class="border-bottom-double text-center" *matHeaderCellDef
                        style="min-width: 180px; padding-right: 15px;">欠損理由</th>
                    <td mat-cell Align="left" *matCellDef="let row" style="height: 88px;">
                        <div *ngIf="row.lossJudgmentDivcd === LOSS_JUDGMENT_DIVCD_MANUAL">
                            <mat-form-field appearance="outline" class="input-form-select"
                                style="margin-left: 0; padding-left: 0; min-width: 180px;">
                                <mat-select id="lossRsncod" [(value)]="row.lossRsncod"
                                    (click)="$event.stopPropagation()" (selectionChange)="onLossRsncodChange()"
                                    required>
                                    <mat-option *ngFor="let div of lossReasonListSelectBox"
                                        [value]="div.value">{{div.viewValue}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div *ngIf="row.lossJudgmentDivcd != LOSS_JUDGMENT_DIVCD_MANUAL">
                            {{ row.lossRsn }}
                        </div>
                    </td>
                </ng-container>
                <ng-container *ngIf="aprovalmodeFlg" matColumnDef="lossRsn">
                    <th mat-header-cell mat-sort-header-container class="border-bottom-double" *matHeaderCellDef
                        mat-sort-header style="min-width: 145px;">欠損理由</th>
                    <td mat-cell *matCellDef="let row" style="height: 88px;">{{ row.lossRsn }}</td>
                </ng-container>
                <ng-container matColumnDef="heisenDate">
                    <th mat-header-cell mat-sort-header-container class="border-bottom-double" *matHeaderCellDef
                        mat-sort-header style="min-width: 75px;">利用停止日</th>
                    <td mat-cell *matCellDef="let row">{{ row.heisenDate | dateString }}</td>
                </ng-container>
                <ng-container matColumnDef="heisenReasonAname">
                    <th mat-header-cell mat-sort-header-container class="border-bottom-double" *matHeaderCellDef
                        mat-sort-header style="min-width: 280px;">利用停止理由</th>
                    <td mat-cell *matCellDef="let row">{{ row.heisenReasonAname }}</td>
                </ng-container>
                <ng-container matColumnDef="payCtrNo">
                    <th mat-header-cell mat-sort-header-container class="border-bottom-double" *matHeaderCellDef
                        mat-sort-header style="min-width: 120px;">支払契約番号</th>
                    <td mat-cell *matCellDef="let row">{{ row.payCtrNo }}</td>
                </ng-container>
                <ng-container matColumnDef="visitName">
                    <th mat-header-cell mat-sort-header-container class="border-bottom-double table-cell-type-num"
                        *matHeaderCellDef mat-sort-header style="min-width: 90px;">請求先名</th>
                    <td mat-cell *matCellDef="let row">{{ row.visitName }}</td>
                </ng-container>
                <ng-container matColumnDef="lossJudgmentdivisionAname">
                    <th mat-header-cell mat-sort-header-container class="border-bottom-double table-cell-type-num"
                        *matHeaderCellDef mat-sort-header style="min-width: 75px;">欠損<br>判定<br>区分</th>
                    <td mat-cell *matCellDef="let row">{{ row.lossJudgmentdivisionAname }}</td>
                </ng-container>
                <ng-container *ngIf="!aprovalmodeFlg" matColumnDef="apprvReqDate">
                    <th mat-header-cell mat-sort-header-container class="border-bottom-double" *matHeaderCellDef
                        mat-sort-header style="min-width: 75px;">承認<br>依頼日</th>
                    <td mat-cell *matCellDef="let row">{{ row.apprvReqDate | dateString }}</td>
                </ng-container>
                <ng-container *ngIf="aprovalmodeFlg" matColumnDef="eachareaApprvDate">
                    <th mat-header-cell mat-sort-header-container class="border-bottom-double" *matHeaderCellDef
                        mat-sort-header style="min-width: 75px;">各地区<br>承認日</th>
                    <td mat-cell *matCellDef="let row">{{ row.eachareaApprvDate | dateString }}</td>
                </ng-container>
                <ng-container matColumnDef="lossSumMny">
                    <th mat-header-cell mat-sort-header-container class="border-bottom-double" *matHeaderCellDef
                        mat-sort-header style="min-width: 105px;">欠損<br>合計金額[円]</th>
                    <td mat-cell class="table-cell-type-num" *matCellDef="let row">{{ row.lossSumMny | number }}</td>
                </ng-container>
                <ng-container matColumnDef="inGasLossmny">
                    <th mat-header-cell mat-sort-header-container class="border-bottom-double" *matHeaderCellDef
                        mat-sort-header style="min-width: 105px;">内ガス<br>欠損金額[円]</th>
                    <td mat-cell class="table-cell-type-num" *matCellDef="let row">{{ row.inGasLossmny | number }}</td>
                </ng-container>
                <ng-container matColumnDef="inElecLossmny">
                    <th mat-header-cell mat-sort-header-container class="border-bottom-double" *matHeaderCellDef
                        mat-sort-header style="min-width: 105px;">内電気<br>欠損金額[円]</th>
                    <td mat-cell class="table-cell-type-num" *matCellDef="let row">{{ row.inElecLossmny | number
                        }}</td>
                </ng-container>
                <ng-container matColumnDef="inEtcLossmny">
                    <th mat-header-cell mat-sort-header-container class="border-bottom-double" *matHeaderCellDef
                        mat-sort-header style="min-width: 105px;">内その他<br>欠損金額[円]</th>
                    <td mat-cell class="table-cell-type-num" *matCellDef="let row">{{ row.inEtcLossmny | number }}</td>
                </ng-container>
                <ng-container matColumnDef="rcptfxMatomeDivAname">
                    <th mat-header-cell mat-sort-header-container class="border-bottom-double" *matHeaderCellDef
                        mat-sort-header style="min-width: 55px;">合算／<br>まとめ</th>
                    <td mat-cell *matCellDef="let row">{{ row.rcptfxMatomeDivAname }}</td>
                </ng-container>
                <ng-container matColumnDef="pressmanagementdivisionAname">
                    <th mat-header-cell mat-sort-header-container class="border-bottom-double" *matHeaderCellDef
                        mat-sort-header style="min-width: 90px;">督促<br>管理区分</th>
                    <td mat-cell *matCellDef="let row">{{ row.pressmanagementdivisionAname }}</td>
                </ng-container>
                <ng-container matColumnDef="pressInchargeregionAname">
                    <th mat-header-cell mat-sort-header-container class="border-bottom-double" *matHeaderCellDef
                        mat-sort-header style="min-width: 70px;">督促<br>管理地区</th>
                    <td mat-cell *matCellDef="let row">{{ row.pressInchargeregionAname }}</td>
                </ng-container>
                <ng-container matColumnDef="chargedivisionAname">
                    <th mat-header-cell mat-sort-header-container class="border-bottom-double" *matHeaderCellDef
                        mat-sort-header style="min-width: 105px; padding: 0 15px">料金区分</th>
                    <td mat-cell *matCellDef="let row">{{ row.chargedivisionAname }}</td>
                </ng-container>
                <tr mat-header-row class="border-bottom-double" *matHeaderRowDef="displayedColumnsCol; sticky: true">
                </tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsCol" class="clickable-mat-row"
                    (dblclick)="this.onDblClickRowEvent.emit(row)"></tr>
            </table>
        </div>
        <mat-paginator #paginator1 [pageSize]="10" showFirstLastButtons></mat-paginator>
        <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-end tw-items-center tw-content-center">
            <mat-card-actions class="btn_area_right">
                <ng-container *ngIf="aprovalmodeFlg">
                    <button type="button" [disabled]="isOutputBtnDisabled" mat-raised-button color="primary" class="btn"
                        (click)="onClickOutput()">
                        出力
                    </button>
                </ng-container>
                <button *ngIf=" !aprovalmodeFlg" type="button" [disabled]="isRegistrationBtnDisabled" mat-raised-button
                    color="primary" class="btn" (click)="onClickRegistration()">
                    登録
                </button>
                <button *ngIf="aprovalmodeFlg" type="button" [disabled]="isApprovalBtnDisabled" mat-raised-button
                    color="primary" class="btn" (click)="onClickApproval()">
                    承認
                </button>
            </mat-card-actions>
        </div>
    </mat-card-content>
</mat-card>